import { render, staticRenderFns } from "./AgeGenderSelect.vue?vue&type=template&id=9eb72e04&"
import script from "./AgeGenderSelect.vue?vue&type=script&lang=js&"
export * from "./AgeGenderSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports